import axios from 'axios';
import jwt from 'jsonwebtoken';
import setAuthorizationToken from "../utils/setAuthorizationToken";
import { url } from '../utils/const';

/**
 * Haal eventuele "bearer " / "Bearer " prefix weg
 * zodat we intern altijd alleen de pure JWT opslaan/gebruiken.
 */
function normalizeJwt(raw) {
    if (!raw) return '';

    var token = ('' + raw).trim();
    var lower = token.toLowerCase();

    if (lower.indexOf('bearer ') === 0) {
        token = token.substring(7).trim();
    }

    return token;
}

/**
 * LOGIN
 * - Authenticatie via backend
 * - JWT opslaan (zonder bearer prefix)
 * - Zet Authorization header
 * - Decodeert JWT en zet decoded authUser in Redux
 */
export function login(data) {
    return function (dispatch) {
        return axios.post(url + '/api/v1/authenticate', data)
            .then(function (res) {
                var token = normalizeJwt(res.data);

                if (!token) {
                    localStorage.removeItem('jwtToken');
                    setAuthorizationToken(false);
                    throw new Error('Lege JWT ontvangen');
                }

                localStorage.setItem('jwtToken', token);
                setAuthorizationToken(token);

                var decodedUser = jwt.decode(token);

                if (!decodedUser) {
                    localStorage.removeItem('jwtToken');
                    setAuthorizationToken(false);
                    throw new Error('JWT kon niet worden gedecodeerd');
                }

                dispatch(setAuthUser(decodedUser));

                return decodedUser;
            })
            .catch(function (err) {
                localStorage.removeItem('jwtToken');
                setAuthorizationToken(false);
                throw err;
            });
    };
}

/**
 * SET_AUTH_USER
 * - Zet authUser in Redux
 */
export function setAuthUser(user) {
    return {
        type: "SET_AUTH_USER",
        payload: user
    };
}

/**
 * LOGOUT
 * - Verwijdert jwtToken
 * - Haalt Authorization header weg
 * - Reset authUser
 */
export function logout() {
    return function (dispatch) {
        localStorage.removeItem('jwtToken');
        setAuthorizationToken(false);

        dispatch({
            type: "LOGOUT_USER"
        });
    };
}